import React from 'react'
import Translation from '../General/Translation'


const Length = ({length, translation}) => {
    if(length === false) {
        return ''
    } else {
        return <p className="text-medium length">
            <svg id="Ebene_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.26 19.26">
                <g id="Ebene_1-2">
                    <path className="cls-1" d="M9.63,1.5c4.48,0,8.13,3.65,8.13,8.13s-3.65,8.13-8.13,8.13S1.5,14.11,1.5,9.63,5.15,1.5,9.63,1.5M9.63,0C4.31,0,0,4.31,0,9.63s4.31,9.63,9.63,9.63,9.63-4.31,9.63-9.63S14.95,0,9.63,0h0Z"/>
                    <polygon className="cls-1" points="13.28 13.32 8.88 10.6 8.88 5.5 10.38 5.5 10.38 9.76 14.07 12.04 13.28 13.32"/>
                </g>
            </svg>
            
            <span className="minutes"> {length} <Translation id="movieLengthUnit" trans={translation}>Minuten</Translation></span>
        </p>
    }
}

export default Length